import {
  call,
  getContext,
  select,
  takeLatest,
} from 'redux-saga/effects';
import { TrackingTypes } from 'reducers/tracking';
import DateHelper from 'utils/dateHelper';

export function* getCommonTrackingParams({ course, teeTime, otherParams = {} }) {
  const { query } = yield select((state) => state.router.location);
  const extraParams = { ...otherParams };
  const teeTimeExtraParams = teeTime?.extraParams || {};

  const courseParams = {
    courseName: course?.name,
    courseId: course?.id,
    courseSlug: course?.slug,
    courseAddress: course?.formattedAddress,
    courseZipCode: course?.addressZipcode,
  };

  const teeTimeParams = teeTime?.teeTimeId ? {
    teeTimeId: teeTime.teeTimeId,
    timeSlot: DateHelper.formatDate(teeTime.teeOffAtLocal, DateHelper.TIME_SLOT, true),
    cart: teeTime.isRiding,
    holes: teeTime.numHoles,
    players: teeTime.players,
    rateTypeLabel: teeTime.rateTypeLabel,
    dateOfBooking: DateHelper.formatDate(new Date(), 'yyyy-MM-DD'),
    dateOfPlay: teeTime?.teeOffAtLocal ? DateHelper.formatDate(teeTime.teeOffAtLocal, 'yyyy-MM-DD') : null,
    platform: query?.isAppClipUrl === 'true' ? 'app_clip' : 'web',
    ...teeTimeExtraParams,
  } : {};

  return { ...courseParams, ...teeTimeParams, ...extraParams };
}

export function* trackEvent({
  eventName,
  dataFields,
}) {
  const iterable = yield getContext('iterable');
  const profile = yield select((state) => state.profile);

  const { loggedIn: userIsLoggedIn, id: userId } = profile;

  if (userIsLoggedIn) {
    yield call(iterable.trackEvent, {
      userId: userId.toString(),
      eventName,
      dataFields: { ref: `${process.env.REACT_APP_ITERABLE_NAME}_web`, ...dataFields },
    });
  }
}

export function* trackGAEvent({ event, params }) {
  if (!event?.name) return;
  let extraParams = {};

  const user = yield select((state) => state.profile);
  if (user?.loggedIn) {
    extraParams.emailAddress = user.email;
    extraParams.sgUserId = user.id;
    extraParams.firstName = user.firstName;
    extraParams.lastName = user.lastName;
  }

  if (params) extraParams = { ...params, ...extraParams };

  const gtm = yield getContext('gtm');
  yield call(gtm.trackEvent, {
    event: event.name,
    eventLabel: event?.label ?? event.name.replaceAll('_', ' '),
    eventAction: event?.action ?? 'click',
    eventCategory: event?.category ?? '',
    extraParams,
  });
}

function* trackEventWatcher() {
  yield takeLatest(TrackingTypes.TRACK_EVENT, trackEvent);
}

function* trackGAEventWatcher() {
  yield takeLatest(TrackingTypes.TRACK_GA_EVENT, trackGAEvent);
}

export default [trackEventWatcher, trackGAEventWatcher];
